export function verboseApiLog(message: string) {
  if (import.meta.env.VITE_ENABLE_API_VERBOSE_LOGGING === "true") {
    console.log(message);
  }
}

export function verboseAuthLog(message: string) {
  if (import.meta.env.VITE_ENABLE_AUTH_VERBOSE_LOGGING === "true") {
    console.log(message);
  }
}
